(async function () {
    const shopifyAuthToken = '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'; // This only has product read scope
    const altProductsContainer = document.querySelector('.alternative-products'); 

    if (altProductsContainer === undefined && altProductsContainer !== null) {
        console.log('Please add .alternative-products div to be able to display Alternative Products');
    } else {
        // Compile array of product ids from list item data attributes
        let alternativeProductIds = [];
        let gids = [];
        let lis = document.querySelectorAll('.alternative-products li');
        for(i = 0; i < lis.length; i++) {
            alternativeProductIds.push(lis[i].dataset.product);
        }

        if(alternativeProductIds.length > 0) {

            const myHeaders = new Headers();
            myHeaders.append('x-api-key', '6XHzlHGCFQ96QW6f4uxN44HCpGvXJf2yL7WN5XSg');
            myHeaders.append('Content-Type', 'application/json');

            const products = await fetch('https://apis.needapart.co.nz/products-by-id?ids=' + alternativeProductIds.join(','), {
                method: 'GET',
                headers: myHeaders,
            }).then((res) => res.json());

            // Check if a valid response was returned.
            if(products) {
                altProductsContainer.style.display = 'block';
                products.forEach(p => {
                    let productId = p.id;
                    let li = document.querySelector('.alternative-products li[data-product="' + productId + '"]');

                    // Image
                    let img = li.querySelector('img.ap-image');
                    img.src = p.image;
                    img.alt = p.title;

                     // Title and link
                     let a = li.querySelector('a.ap-title');
                     a.href = '/products/' + p.handle;
                     a.innerHTML = p.title;

                    // Brand
                    let b = li.querySelector('.ap-brand');
                    b.innerHTML = p.vendor;
                });
            } else {
                // 
            }
        }
    }
})();